// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__22ytk","inputWrap":"Table_inputWrap__1bYak","col":"Table_col__2VcyD","bmiTooltip":"Table_bmiTooltip__lkqax"};